module.exports = __webpack_public_path__ + "assets/img/mainItem02.59e956f4.svg";